import { useState, type ReactNode } from 'react';
import { closeApp, copyText } from '../telegram';

export function Header({
  title,
  action,
  onBack,
}: {
  title: string;
  action?: ReactNode;
  onBack?: () => void;
}) {
  return (
    <div className="header">
      <button type="button" aria-label={onBack || window.location.hash && !window.location.hash.includes("home") ? "返回钱包" : "关闭"} onClick={onBack ?? (() => { if (window.location.hash && !window.location.hash.includes("home")) window.location.hash = "#/home"; else closeApp(); })}>
        {onBack || window.location.hash && !window.location.hash.includes('home') ? '‹' : '×'}
      </button>
      <h1>{title}</h1>
      <div style={{ textAlign: 'right' }}>{action}</div>
    </div>
  );
}

export function WalletId({ id, pinReady }: { id: string; pinReady?: boolean }) {
  return (
    <div className="wallet-id">
      TG(钱包) ID：<b className="mono">{id}</b>{' '}
      {pinReady === undefined ? null : (
        <span className={pinReady ? 'on' : ''}>({pinReady ? '已开启' : '未设置密码'})</span>
      )}
    </div>
  );
}

export function Tabs<T extends string>({
  tabs,
  active,
  onChange,
}: {
  tabs: { key: T; label: string }[];
  active: T;
  onChange: (key: T) => void;
}) {
  return (
    <div className="tabs">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          type="button"
          className={tab.key === active ? 'active' : ''}
          onClick={() => onChange(tab.key)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}

export function Segmented<T extends string>({
  options,
  active,
  onChange,
}: {
  options: { key: T; label: string }[];
  active: T;
  onChange: (key: T) => void;
}) {
  return (
    <div className="segmented">
      {options.map((option) => (
        <button
          key={option.key}
          type="button"
          className={option.key === active ? 'active' : ''}
          onClick={() => onChange(option.key)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}

export function Field({
  label,
  children,
  hint,
}: {
  label: string;
  children: ReactNode;
  hint?: ReactNode;
}) {
  return (
    <div className="field">
      <label>{label}</label>
      <div className="control">{children}</div>
      {hint ? <div className="hint">{hint}</div> : null}
    </div>
  );
}

export function Rows({ items }: { items: [string, ReactNode][] }) {
  return (
    <div className="rows">
      {items.map(([label, value]) => (
        <div className="row" key={label}>
          <span>{label}</span>
          <span>{value}</span>
        </div>
      ))}
    </div>
  );
}

export function Toggle({
  label,
  hint,
  value,
  onChange,
}: {
  label: string;
  hint?: string;
  value: boolean;
  onChange: (value: boolean) => void;
}) {
  return (
    <div className="toggle">
      <div>
        <div>{label}</div>
        {hint ? <div className="hint">{hint}</div> : null}
      </div>
      <button
        type="button"
        aria-pressed={value}
        className={`switch ${value ? 'on' : ''}`}
        onClick={() => onChange(!value)}
      />
    </div>
  );
}

export function CopyText({ value }: { value: string }) {
  const [copied, setCopied] = useState(false);
  return <button type="button" className="copy-text mono" onClick={async () => { await copyText(value); setCopied(true); }} title="点击复制">{value}<span aria-live="polite">{copied ? '已复制' : '复制'}</span></button>;
}

export function Empty({ text }: { text: string }) {
  return (
    <div className="empty">
      <span className="icon">🗂</span>
      {text}
    </div>
  );
}

export function Notice({ children }: { children: ReactNode }) {
  return <div className="notice">⚠️ {children}</div>;
}
